var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"demo-mode"}},[(_vm.TestMode)?_c('div',{staticClass:"fixed-header"},[_c('h1',{staticClass:"fixed-header-txt"},[_c('v-icon',{attrs:{"color":"#000000"}},[_vm._v(" mdi-information ")]),_vm._v(" YOU'RE IN TEST MODE ")],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }